export const OWNERS = [
  { value: "meu", label: "Meu" },
  { value: "seu", label: "Seu" },
  { value: "nosso", label: "Nosso" },
];

export const TX_TYPES = [
  { value: "entrada", label: "Entrada", hint: "dinheiro que chegou" },
  { value: "gasto", label: "Gasto", hint: "dinheiro que usamos" },
  { value: "aporte", label: "Aporte", hint: "dinheiro pro futuro" },
];

export const INCOME_KINDS = [
  { value: "salario", label: "Salário" },
  { value: "variavel", label: "Variável / freela" },
  { value: "beneficio", label: "Benefício" },
  { value: "extra", label: "Extra" },
];

export const ASSET_KINDS = [
  { value: "reserva", label: "Reserva" },
  { value: "investimento", label: "Investimento" },
  { value: "imovel", label: "Imóvel / bem" },
  { value: "outro", label: "Outro" },
];

export const SPLIT_METHODS = [
  { value: "50_50", label: "50 / 50", desc: "Metade pra cada." },
  { value: "proporcional", label: "Proporcional à renda", desc: "Quem ganha mais, contribui mais." },
  { value: "responsabilidade", label: "Por responsabilidade", desc: "Cada um paga o que assumiu." },
  { value: "personalizado", label: "Personalizado", desc: "Percentual que vocês definirem." },
  { value: "fixo", label: "Valor fixo", desc: "Um valor combinado pra cada." },
];

export const GOAL_COVERS = [
  "https://images.unsplash.com/photo-1758523669954-90b13f9854b4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  "https://images.pexels.com/photos/5481511/pexels-photo-5481511.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "https://images.unsplash.com/photo-1758522485213-22d3af7f27c7?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  "https://images.pexels.com/photos/36729946/pexels-photo-36729946.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "https://images.unsplash.com/photo-1560439972-a9f468a21f2a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
];
